const roles = [
  {
    id: 'functional-supply-chain-consultant',
    slug: 'functional-supply-chain-consultant',
    hireonId: 97,
    title: 'Functional Supply Chain Consultant',
    department: 'Supply Chain',
    location: 'Bengaluru, India',
    type: 'Full-Time',
    mode: 'Hybrid',
    tags: ['Supply Chain', 'Senior Level', 'Full-Time'],
    summary:
    'Act as a functional supply chain expert, helping enterprise clients design and implement scalable planning solutions across Demand Planning, Supply Planning, S&OP/IBP, and Inventory Optimization using the o9 Solutions platform.',
    responsibilities: [
     'Act as a functional expert in supply chain planning, o9 Solutions, and end-to-end planning processes across CPG, Retail, Consumer Goods, and Manufacturing.',
     'Design and configure Demand Planning, Supply Planning, S&OP/IBP, and Inventory Optimization solutions on the o9 platform.',
     'Configure planning models, workflows, measures, dimensions, business rules, planning views, and user roles.',
     'Design and support forecasting, demand sensing, MRP, MPS, DRP, replenishment, deployment, and MEIO processes.',
     'Conduct solutioning workshops, understand client requirements, and translate business challenges into scalable planning solutions.',
     'Enable scenario planning, what-if analysis, exception-based planning, and supply chain analytics to improve planning decisions.',
     'Define master data requirements and integration touchpoints between o9, ERP, manufacturing, procurement, warehouse, and other enterprise systems.',
     'Support implementation, testing, user adoption, and continuous improvement of o9-based planning solutions.',
    ],
    qualifications: [
      '3–5 years of experience in Supply Chain Planning, Demand Planning, Supply Planning, S&OP/IBP, or Inventory Optimization.',
      'Hands-on experience implementing, configuring, and designing solutions using the o9 Solutions / o9 Digital Brain platform.',
      'Strong functional knowledge of Demand Planning, Supply Planning, S&OP/IBP, Inventory Optimization, MEIO, MRP/MPS/DRP, Replenishment, Demand Sensing, and Forecasting.',
      'Experience in CPG, Retail, Consumer Goods, or Manufacturing industries.',
      'Strong understanding of statistical forecasting, scenario planning, supply chain analytics, and planning methodologies.',
      'Experience in client-facing consulting, stakeholder management, and solution workshops.',
      "Bachelor's degree in Supply Chain, Industrial Engineering, Operations, Business, or a related field.",
      'Knowledge of SQL and exposure to Python/R for supply chain analytics is desirable.',
    ],
    characteristics: [
      'Strong techno-functional understanding of supply chain planning and o9 Solutions.',
      'Able to translate complex business requirements into practical, scalable planning solutions.',
      'Strong analytical and problem-solving skills with a structured approach to supply chain challenges.',
      'Confident communicator who can work effectively with business, supply chain, technology, and client teams.',
      'Collaborative team player with strong ownership and a continuous improvement mindset.',
      'Comfortable working in a dynamic, client-facing consulting environment.',
    ],
  },
  {
    id: 'supply-chain-trainee',
    slug: 'supply-chain-trainee',
    hireonId: 88,
    title: 'Supply Chain Trainee',
    department: 'Supply Chain',
    location: 'Bengaluru, India',
    type: 'Full-Time',
    mode: 'Hybrid',
    tags: ['Supply Chain', 'Entry Level', 'Full-Time'],
    summary:
      'Kickstart your career in supply chain consulting by supporting senior experts on real enterprise transformation projects - from requirements gathering to platform configuration and user training.',
    responsibilities: [
      'Support consultants in analyzing and documenting supply chain business processes and system workflows.',
      'Assist in gathering and validating customer requirements for supply chain planning solution design and implementation.',
      'Identify functional gaps in existing platforms and coordinate with cross-functional teams to resolve business problems.',
      'Assist in configuring supply chain planning tools based on change requests, ensuring accurate and timely post go-live delivery.',
      'Execute test cases for workflow and data validation; track and manage bugs using internal support tools.',
      'Contribute to Super User and End User training material preparation and delivery for a global user base.',
    ],
    qualifications: [
      'BTech / MCA / MTech / MBA in Supply Chain Management, Operations, Information Systems, or a related field.',
      '0–2 years in supply chain planning, ERP consulting, or related roles. Exposure to o9, Kinaxis, Blue Yonder, Oracle ASCP, or SAP APO is preferred.',
      'Basic knowledge of SQL or T-SQL; familiarity with R, SAS, or CPLEX is an advantage.',
      'Foundational understanding of Demand Management, Distribution Planning, Master Planning, and S&OP concepts.',
    ],
    characteristics: [
      'Eager to learn and apply supply chain domain knowledge in a techno-functional environment.',
      'Clear communicator who can effectively engage with both technical and business stakeholders.',
      'Detail-oriented and organized, capable of managing multiple tasks within tight deadlines.',
      'Collaborative and adaptable, comfortable working across global cross-functional teams.',
      'Self-driven with a proactive approach to problem-solving and strong ownership of deliverables.',
    ],
  },

  {
    id: 'data-integration-consultant',
    slug: 'data-integration-consultant',
    hireonId: 90,
    title: 'Data Integration Consultant',
    department: 'Data Integration',
    location: 'Bengaluru, India',
    type: 'Full-Time',
    mode: 'Hybrid',
    tags: ['Data Integration', 'Mid Level', 'Full-Time'],
    summary:
      'Act as a techno-functional expert in data integration - designing end-to-end pipelines, resolving data quality issues, and ensuring seamless data flow across enterprise platforms for global clients.',
    responsibilities: [
      'Act as a techno-functional expert in data integration best practices, ETL/ELT methodologies, enterprise data architectures, and end-to-end pipeline design.',
      'Analyze client data requirements and design integration solutions that ensure accurate, seamless, and timely data flow across systems and platforms.',
      'Identify data quality issues, reconciliation gaps, and system compatibility challenges; coordinate with cross-functional teams to deliver reliable integration outcomes.',
      'Configure and maintain data integration pipelines based on change requests and post go-live enhancements, ensuring continuous data accuracy and operational efficiency.',
      'Execute data transformation, validation, and reconciliation test cases; track and resolve bugs and discrepancies using internal support tools.',
      'Support Super User and End User training on integration tools, workflows, and best practices for a global user base.',
    ],
    qualifications: [
      'BTech / MCA / MTech / MBA in Computer Science, Information Systems, Data Engineering, or a related field.',
      '3–5 years implementing data integration solutions using tools such as Informatica, Dell Boomi, Talend, AWS Glue, Apache NiFi, or SnapLogic. API integration (REST/SOAP) and cloud platform experience is a must.',
      'Proficiency in SQL, T-SQL, or MDX; working knowledge of Python, JSON, or XML for pipeline scripting is highly desirable.',
      'Strong understanding of ETL/ELT, data warehousing, data mapping, data governance, API integration, and real-time vs. batch data processing.',
    ],
    characteristics: [
      'Leads by example with deep proficiency in both integration technology and the data domain.',
      'Communicates complex integration concepts clearly to non-technical stakeholders, even under pressure.',
      'Detail-oriented and analytical, with a structured approach to troubleshooting across multi-system environments.',
      'Collaborative team player, comfortable working across global business, IT, and data engineering teams.',
      'Self-motivated with a continuous improvement mindset and strong ownership over data quality and integration performance.',
    ],
  },

 

  {
    id: 'software-engineer',
    slug: 'software-engineer',
    hireonId: 91,
    title: 'Software Engineer',
    department: 'Engineering',
    location: 'Bengaluru, India',
    type: 'Full-Time',
    mode: 'Hybrid',
    tags: ['Engineering', 'Mid Level', 'Full-Time'],
    summary:
      'Design, develop, and maintain scalable software applications and RESTful APIs - collaborating across product, architecture, and business teams to deliver high-quality, enterprise-grade solutions.',
    responsibilities: [
      'Design, develop, and maintain scalable software applications in line with business requirements and engineering best practices.',
      'Collaborate with product managers and architects to translate business needs into clean, efficient, and testable code.',
      'Debug and resolve software defects across development and production environments, ensuring high code quality and performance.',
      'Build and maintain RESTful APIs and microservices to enable seamless data exchange across internal and external systems.',
      'Write and execute unit, integration, and end-to-end test cases; track bug resolution using tools such as Jira or Azure DevOps.',
      'Participate in code reviews, sprint planning, and technical design sessions to ensure quality and on-time delivery.',
    ],
    qualifications: [
      'BTech / MCA / MTech in Computer Science, Software Engineering, or a related field.',
      '3–5 years in software development using Java, Python, C#, or Node.js; experience in cloud-native and Agile environments is preferred.',
      'Proficiency in SQL/NoSQL databases, Git, CI/CD pipelines, Docker, and cloud platforms (AWS, Azure, or GCP).',
      'Strong understanding of OOP, SOLID principles, REST API design, microservices architecture, and Agile/Scrum methodologies.',
    ],
    characteristics: [
      'Takes full ownership of technical deliverables with a strong solution-oriented mindset.',
      'Communicates technical decisions clearly to both technical and non-technical stakeholders.',
      'Writes clean, well-documented, and maintainable code that meets team standards.',
      'Collaborative team player who contributes to knowledge sharing and peer learning.',
      'Self-driven with a continuous learning mindset and a strong accountability for delivery quality.',
    ],
  },
];

export default roles;